export const CONTACT_INFO = {
    whatsapp: "https://wa.me/5516981442301?text=Olá%20Roldan%2C%20gostaria%20de%20conversar%20sobre%20um%20projeto",
    email: "mailto:roldan.eng.software@gmail.com",
};

export const SERVICES = [
    {
        icon: "💻",
        title: "Desenvolvimento de Software",
        desc: "Softwares personalizados que resolvem seus problemas específicos"
    },
    {
        icon: "🎯",
        title: "Landing Pages",
        desc: "Páginas otimizadas para converter visitantes em clientes"
    },
    {
        icon: "🚀",
        title: "MicroSaaS",
        desc: "Plataformas escaláveis para seu negócio online"
    },
    {
        icon: "⚙️",
        title: "Automações",
        desc: "Economize tempo automatizando processos repetitivos"
    },
    {
        icon: "📊",
        title: "Análise de Dados",
        desc: "Decisões inteligentes baseadas em seus dados"
    }
];

export const FAQS = [
    {
        q: "Quanto custa um projeto?",
        a: "Depende da complexidade. Fazemos uma análise gratuita e apresentamos um orçamento transparente."
    },
    {
        q: "Quanto tempo leva?",
        a: "Projetos simples levam semanas, projetos maiores alguns meses. Definimos prazos claros desde o início."
    },
    {
        q: "Vocês fazem suporte após o lançamento?",
        a: "Sim! Oferecemos suporte técnico e manutenção para garantir que seu projeto funcione sempre bem."
    },
    {
        q: "Posso comunicar via WhatsApp?",
        a: "Claro! Você pode falar comigo direto pelo WhatsApp. Atendimento rápido e personalizado é nosso diferencial."
    },
    {
        q: "Como é o processo de desenvolvimento?",
        a: "Descoberta → Planejamento → Design → Desenvolvimento → Testes → Lançamento → Suporte"
    }
];

export const SOCIAL_LINKS = {
    instagram: "https://instagram.com/roldan.eng.software",
    whatsapp: CONTACT_INFO.whatsapp,
    email: CONTACT_INFO.email
};
